module.exports = __webpack_public_path__ + "static/media/Arrow.57fc184b.svg";